import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appPercentInput]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PercentInputDirective),
      multi: true
    }
  ]
})
export class PercentInputDirective implements ControlValueAccessor {
  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };
  private regex = /^\d+(\.\d{0,6})?$/;

  private isFocused = false;

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event.target.value'])
onInput(value: string): void {
  let numeric = value.replace(/[^0-9.]/g, '');

  // Remove multiple decimals
  const parts = numeric.split('.');
  if (parts.length > 2) {
    numeric = parts[0] + '.' + parts.slice(1).join('');
  }

  // 👇 handle empty input explicitly
  if (numeric.trim() === '') {
    this.lastValidDisplay = '';
    this.onChange('');
    this.el.nativeElement.value = '';
    return;
  }

  if (!this.regex.test(numeric)) {
    this.writeValue(this.lastValidDisplay);
    return;
  }

  this.lastValidDisplay = numeric;
  this.onChange(numeric);
  this.updateView(numeric);
}


  @HostListener('blur')
  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
    const value = this.el.nativeElement.value.replace('%', '').trim();
    if (value) {
      this.updateView(value);
    }
  }

  @HostListener('focus')
  onFocus(): void {
    this.isFocused = true;
    const value = this.el.nativeElement.value.replace('%', '').trim();
    this.el.nativeElement.value = value;
  }

  writeValue(value: any): void {
    if (value != null && value !== '') {
      this.updateView(value);
    } else {
      this.el.nativeElement.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  private lastValidDisplay = '';

  private updateView(value: string) {
    if (value) {
      this.el.nativeElement.value = value + (this.isFocused ? '' : ' %');
    } else {
      this.el.nativeElement.value = '';
    }
  }
}
